import { NEOVIS_ADVANCED_CONFIG, NeovisConfig } from 'neovis.js';
import { EnvService } from 'src/app/services/env.service';

interface Node {
  image: string;
}

let env = new EnvService();

function getLabelValue(properties: any, keys: string[]): string {
  for (const key of keys) {
    const value = properties[key];
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }
  return 'N/A';
}

export const Default_Config: NeovisConfig = {
  containerId: 'vis-chart',
  neo4j: {
    serverUrl: env.URL_NEO4J,
    serverUser: 'neo4j',
    serverPassword: '12341234',
  },
  visConfig: {
    nodes: {
      shape: 'circle',
      borderWidth: 2,
      font: {
        color: '#110c2a',
        strokeWidth: 0,
        background: '#110c2a',
        size: 10, // Cambia el tamaño del texto
      },
      // Cambia la forma de los nodos de cuadrada a redondeada
      shapeProperties: {
        borderRadius: 0,
      },
    },
    edges: {
      arrows: {
        to: {
          enabled: true,
        },
      },
      color: '#f8dd6a',
      scaling: {
        min: 0,
        max: 5,
      },
    },
  },
  labels: {
    Customer: {
      label: 'Nombre',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/cliente_banco_entidad.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    persona: {
      label: 'value',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/person.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
        function: {
          label: (node) => {
            // "node" es el parámetro que recibes (contiene identity, labels, properties)
            const props = node.properties; // Accedes a las propiedades reales aquí
            return getLabelValue(props, [
              'person', // "Maria Fernanda" (este existe en tu JSON)
              'alias', // "a.alvess7_"
              'first_name',
              'last_name',
              'name',
              'fullname',
            ]);
          },
        },
      },
    },
    telefono: {
      label: 'phone',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/telefono.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    compania: {
      label: 'company',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/compania.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    truecaller: {
      label: 'phone',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/true.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    'Companies House Search Officers by Phrase': {
      label: 'name',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/open.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    'Instagram Get Entity by ID or Alias or URL or Code': {
      label: 'name',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/LoginUser.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    'Facebook Search Users by Different Parameters': {
      label: 'name',
      value: 'value',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/fb.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    Account: {
      label: 'id',
      value: 'Account',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image: 'assets/images/cuenta_bancaria.png',
          brokenImage:
            'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    case: {
      label: 'gai',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image:
            'https://www.nicepng.com/png/detail/253-2531006_case-study-blue-icon-case-icon.png',
          brokenImage:
            'https://www.nicepng.com/png/detail/253-2531006_case-study-blue-icon-case-icon.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    case_type: {
      label: 'name',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          color: '#f8dd6a',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    user: {
      label: 'fullname',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'image',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            background: '#110c2a',
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    auditory_logs: {
      label: 'action',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#28a745',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    blocked_user: {
      label: '_id',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'circle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#28a79c',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    case_file: {
      label: 'name',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a72828',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    case_record: {
      label: 'action',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a72891',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    comment: {
      label: 'comment',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#3d28a7',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    graph_searches: {
      label: 'reference',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#8328a7',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    group_user: {
      label: '_id',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#28a78b',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    group: {
      label: 'name',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#28a75c',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    log: {
      label: 'typeLog',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#8da728',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    notification: {
      label: 'title',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a78128',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    record: {
      label: 'action',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a72f28',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    replace: {
      label: 'replace',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a72f28',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    role: {
      label: 'name',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a72f28',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    task_case: {
      label: 'title',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#5ea728',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    task_file: {
      label: 'name',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#2837a7',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    task: {
      label: 'title',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#a72879',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    unit: {
      label: 'name',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'triangle',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#28a785',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
    user_data: {
      label: 'document',
      value: 'id',
      [NEOVIS_ADVANCED_CONFIG]: {
        static: {
          shape: 'square',
          image:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          color: '#35a728',
          brokenImage:
            'https://w7.pngwing.com/pngs/419/473/png-transparent-computer-icons-user-profile-login-user-heroes-sphere-black-thumbnail.png',
          font: {
            color: '#fff',
            strokeWidth: 0,
            size: 10, // Cambia el tamaño del texto
          },
        },
      },
    },
  },
  relationships: {
    HAS_ACCOUNT: {
      value: 'account',
    },
    HAS_TRANSFERED: {
      title: 'transfer_amount',
      value: 'transfer_amount',
      width: 'transfer_amount',
    },
    HAS_CASE: {
      value: 'id',
    },
    ONE_TO_ONE: {
      value: '_id',
    },
    HAS_TRUECALLER: {
      title: 'type',
      value: 'type',
    },
    HAS_COMPANIES_HOUSE_SEARCH_OFFICERS_BY_PHRASE: {
      title: 'type',
      value: 'type',
    },
    HAS_INSTAGRAM_GET_ENTITY_BY_ID_OR_ALIAS_OR_URL_OR_CODE: {
      title: 'type',
      value: 'type',
    },
    HAS_FACEBOOK_SEARCH_USERS_BY_DIFFERENT_PARAMETERS: {
      title: 'type',
      value: 'type',
    },
    HAS_PERSONA: {
      title: 'type',
      value: 'type',
    },
    HAS_TELEFONO: {
      title: 'type',
      value: 'type',
    },
    HAS_COMPANIA: {
      title: 'type',
      value: 'type',
    },
  },
  initialCypher: `
    match (c:Customer) WHERE c.Nombre =~ '(?i).*27145476.*' OR c.id =~ '(?i).*27145476.*' RETURN c LIMIT 10
  `,
  consoleDebug: true,
};
